import React, { Component } from "react";
import "./SignInCourtiers.css"
import serializeForm from "form-serialize";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'

import {
  fetchSignInCourtiersAction,
} from "../../actions/Authentification/SignInCourtiers";

import { 
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class SignInCourtiers extends Component {

  state = {
    notificationSignInCourtiersError: false,
    isSuccessLogin: false,
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Connexion courtiers`;

    this.props.getReauthenticateCourtiers()
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.signInCourtiers.isSuccess !== this.props.signInCourtiers.isSuccess) {
      this.setState({ isSuccessLogin: nextProps.signInCourtiers.isSuccess })
    }
    if (nextProps.signInCourtiers.isError !== this.props.signInCourtiers.isError) {
      this.setState({ notificationSignInCourtiersError: nextProps.signInCourtiers.isError });
    }
  }

  handleSubmit = event => {
    const { login } = this.props;
    event.preventDefault();
    const FormValues = serializeForm(event.target, { hash: true });

    if (Object.keys(FormValues).length !== 0) {
      login(serializeJavascript.sanitize(FormValues));
    }
  };

  render() {
    const {signInCourtiers, reauthenticateCourtiers} = this.props;
    const {
      notificationSignInCourtiersError,
      isSuccessLogin,
    } = this.state

    return (
      <div>
        <Header userIsSuccessLogin={isSuccessLogin} />
        <div className="aps-container-center-bloc">
          {(signInCourtiers.isLoading || reauthenticateCourtiers.isLoading) ? (
            <div className="aps-spinner-container-loading">
              <div className="uk-spinner">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 30 30"
                  ratio="1"
                >
                  <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14" />
                </svg>
              </div>
              <div className="aps-section-register-desc">
                chargement en cours
              </div>
            </div>
          ) : (
            <div className="aps-section-connexion-padding">
              <div className="uk-section aps-section-connexion">
                <div>
                  <h3 className="uk-text-center aps-section-connexion-title">
                    Connectez-vous en tant que courtier ...
                  </h3>
                </div>
                {((signInCourtiers.isSuccess && isSuccessLogin) || (reauthenticateCourtiers.isSuccess)) &&
                  <div> <Redirect to="/" push /> </div>
                }
                {(signInCourtiers.isError && notificationSignInCourtiersError) && (
                  <div className="uk-text-center aps-section-connexion-notification-invalid-email-password">
                    Email ou mot de passe incorrect
                  </div>
                )}
                <form onSubmit={this.handleSubmit}>
                  <div className="uk-text-center aps-section-connexion-fields-container">
                    <div className="uk-inline aps-section-connexion-input-full">
                      <span className="uk-form-icon" uk-icon="icon: user" />
                      <input
                        className="uk-input aps-section-connexion-input"
                        type="email"
                        placeholder="Email"
                        name="email"
                      />
                    </div>
                  </div>
                  <div className="uk-text-center">
                    <div className="uk-inline aps-section-connexion-input-full">
                      <span className="uk-form-icon" uk-icon="icon: lock" />
                      <input
                        className="uk-input aps-section-connexion-input"
                        type="password"
                        placeholder="Mot de passe"
                        name="password"
                      />
                    </div>
                  </div>
                  <div className="uk-text-center aps-section-connexion-action-btn">
                    <button className="uk-button aps-section-connexion-action-btn-full">
                      Se connecter
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({
  signInCourtiers,
  reauthenticateCourtiers
}) => {
  return {
    signInCourtiers,
    reauthenticateCourtiers
  };
};
const mapDispatchToProps = dispatch => {
  return {
    login: courtierData => dispatch(fetchSignInCourtiersAction(courtierData)),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInCourtiers);



// WEBPACK FOOTER //
// ./src/containers/SignInCourtiers/index.js